// ---------------------------------------------------------
// WARNING: THIS IS A GENERATED FILE, DO NOT EDIT DIRECTLY
// ---------------------------------------------------------

import { withNamespace } from '../util/withNamespace';
var theme = {
  accessibility: {
    targetSize: 44
  },
  animations: {
    defaultDuration: 0.2,
    defaultTimingFunction: 'ease-out'
  },
  borderWidths: {
    none: 0,
    xs: 1,
    sm: 2,
    md: 4,
    lg: 6,
    xl: 8
  },
  breakpoints: {
    xs: 0,
    sm: 321,
    md: 481,
    lg: 769,
    xl: 1024,
    xxl: 1281
  },
  colors: {
    white: '#FFF',
    gray100: '#F9F9FB',
    gray200: '#F1F1F4',
    gray300: '#D1D1D5',
    gray400: '#A7A6AB',
    gray500: '#54545A',
    gray600: '#2A2A33',
    black: '#0A0A14',
    trueBlack: '#000',
    coolGray100: '#F6F6FA',
    coolGray200: '#EFF3F9',
    coolGray300: '#DEE3E6',
    coolGray400: '#A6B3C4',
    coolGray500: '#596B82',
    coolGray600: '#313F51',
    blue100: '#F2FAFF',
    blue200: '#E0F2FF',
    blue300: '#A6E5FF',
    blue375: '#579DFF',
    blue400: '#006AFF',
    blue500: '#0D4599',
    blue600: '#001751',
    yellow100: '#FFF8E1',
    yellow200: '#FFDC69',
    yellow300: '#FFD237',
    yellow400: '#F2A619',
    yellow500: '#C88205',
    yellow600: '#8A5700',
    orange100: '#F8CFBA',
    orange200: '#F3AE8B',
    orange300: '#EE8E5D',
    orange400: '#E96E2F',
    orange500: '#D05416',
    orange600: '#933100',
    green100: '#D8F4DE',
    green200: '#63E37D',
    green300: '#3DCA5A',
    green400: '#17B036',
    green500: '#128A29',
    green600: '#055E16',
    aqua100: '#D5F3F9',
    aqua200: '#50E3FF',
    aqua300: '#2BC1E1',
    aqua400: '#059EC2',
    aqua500: '#0484A7',
    aqua600: '#03698C',
    purple100: '#F0E3FF',
    purple200: '#CE8DFF',
    purple300: '#B375FF',
    purple400: '#985DFF',
    purple500: '#7A48D6',
    purple600: '#5B33AD',
    red100: '#FFE3E2',
    red200: '#FFADB0',
    red300: '#FF7370',
    red400: '#FF5A50',
    red500: '#E82B27',
    red600: '#A3000B',
    red700: '#7C0012',
    orangeRed100: '#FFBFAD',
    orangeRed200: '#FF9679',
    orangeRed300: '#FF6B45',
    orangeRed400: '#DB3A00',
    orangeRed500: '#BE1C00',
    orangeRed600: '#AF1500',
    facebook: '#1877F2',
    twitter: '#55ACEE',
    linkedIn: '#0077B5',
    x: '#000000',
    none: 'none',
    transparent: 'transparent',
    brand: '#006AFF',
    brandSecondary: '#F2A619',
    backgroundBrand: '#006AFF',
    textWhite: '#FFF',
    textLight: '#A7A6AB',
    textMedium: '#596B82',
    textDark: '#2A2A33',
    link: '#0D4599',
    linkFocus: '#0D4599',
    linkInverse: '#FFF',
    linkInverseHover: '#F9F9FB',
    linkInverseActive: '#F1F1F4',
    linkInverseVisited: '#CE8DFF',
    linkVisited: '#5B33AD',
    linkHover: '#001751',
    linkActive: '#001751',
    linkPressed: '#000',
    backgroundAqua: '#D5F3F9',
    backgroundBlue: '#F2FAFF',
    backgroundGreen: '#D8F4DE',
    backgroundOrange: '#F8CFBA',
    backgroundOrangeRed: '#FFBFAD',
    backgroundPurple: '#F0E3FF',
    backgroundRed: '#FFE3E2',
    backgroundYellow: '#FFF8E1',
    backgroundDarkAqua: '#03698C',
    backgroundDarkBlue: '#001751',
    backgroundDarkGreen: '#055E16',
    backgroundDarkOrange: '#933100',
    backgroundDarkOrangeRed: '#AF1500',
    backgroundDarkPurple: '#5B33AD',
    backgroundDarkRed: '#A3000B',
    backgroundDarkYellow: '#8A5700',
    backgroundWhite: '#FFF',
    backgroundLight: '#F9F9FB',
    backgroundDark: '#2A2A33',
    borderAqua: '#0484A7',
    borderBlue: '#0D4599',
    borderGreen: '#128A29',
    borderOrange: '#D05416',
    borderOrangeRed: '#E82B27',
    borderPurple: '#7A48D6',
    borderRed: '#E82B27',
    borderYellow: '#C88205',
    borderLight: '#D1D1D5',
    borderDark: '#A7A6AB',
    offMarket: '#A7A6AB',
    comingSoon: '#006AFF',
    recentlySold: '#FFD237',
    forRent: '#985DFF',
    forSale: '#FF5A50',
    primary100: '#F2FAFF',
    primary200: '#E0F2FF',
    primary300: '#A6E5FF',
    primary400: '#006AFF',
    primary500: '#0D4599',
    primary600: '#001751',
    secondary100: '#FFF8E1',
    secondary200: '#FFDC69',
    secondary300: '#FFD237',
    secondary400: '#F2A619',
    secondary500: '#C88205',
    secondary600: '#8A5700'
  },
  defaultUnit: 'px',
  fonts: {
    sansSerif: '"Open Sans","Adjusted Arial",Tahoma,Geneva,sans-serif',
    serif: '"Ivar Headline","Ivar Headline Subset","Adjusted Times","Adjusted Times New Roman","Times New Roman",serif'
  },
  fontSizes: {
    h0: 96,
    h1: 60,
    h2: 48,
    h3: 36,
    h4: 24,
    h5: 20,
    h6: 16,
    bodyHeading: 16,
    body: 16,
    bodySmallHeading: 14,
    bodySmall: 14,
    finePrintHeading: 12,
    finePrint: 12,
    legal: 10
  },
  fontWeights: {
    bold: 700,
    normal: 400,
    h0: 700,
    h1: 700,
    h2: 700,
    h3: 700,
    h4: 700,
    h5: 700,
    h6: 700,
    bodyHeading: 700,
    body: 400,
    bodySmallHeading: 700,
    bodySmall: 400,
    finePrintHeading: 700,
    finePrint: 400,
    legal: 400
  },
  gridBase: 8,
  icons: {
    sizes: {
      xs: 16,
      sm: 24,
      md: 32,
      lg: 44
    }
  },
  detailedIcons: {
    sizes: {
      sm: 44
    }
  },
  lineHeights: {
    h0: 112,
    h1: 72,
    h2: 64,
    h3: 40,
    h4: 32,
    h5: 24,
    h6: 24,
    bodyHeading: 24,
    body: 24,
    bodySmallHeading: 24,
    bodySmall: 24,
    finePrintHeading: 16,
    finePrint: 16,
    legal: 16
  },
  opacities: {
    opacity100: 0.2,
    opacity200: 0.4,
    opacity300: 0.6,
    opacity400: 0.8,
    opacity500: 1,
    disabled: 0.4,
    mask: 0.2
  },
  radii: {
    none: 0,
    sm: 2,
    md: 4,
    lg: 8,
    ellipse: '50%',
    pill: '999px'
  },
  shadows: {
    none: 'none',
    shadow100: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
    shadow200: '0 4px 8px 0 rgba(0, 0, 0, 0.3)',
    shadow300: '0 8px 12px 0 rgba(0, 0, 0, 0.3)',
    shadow400: '0 15px 30px 0 rgba(0, 0, 0, 0.3)',
    focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
  },
  spacing: {
    none: 0,
    xxs: 4,
    xs: 8,
    sm: 16,
    md: 24,
    lg: 32,
    xl: 48
  },
  sizes: {
    heights: {
      xs: 28,
      sm: 36,
      md: 44,
      lg: 56
    }
  },
  zIndices: {
    modal: 100002,
    popover: 100011,
    dialog: 100013,
    toast: 200000
  },
  grid: {
    columns: 12,
    columnWidth: 88,
    gap: 16
  },
  status: {
    fontType: 'body',
    iconSize: 24,
    error: {
      background: '#FFE3E2',
      border: '#E82B27',
      foreground: '#E82B27',
      fontColor: '#A3000B',
      darkBackground: '#A3000B'
    },
    info: {
      background: '#F2FAFF',
      border: '#0D4599',
      foreground: '#001751',
      fontColor: '#001751',
      darkBackground: '#001751'
    },
    success: {
      background: '#D8F4DE',
      border: '#128A29',
      foreground: '#128A29',
      fontColor: '#055E16',
      darkBackground: '#055E16'
    },
    warning: {
      background: '#FFF8E1',
      border: '#C88205',
      foreground: '#E96E2F',
      fontColor: '#8A5700',
      darkBackground: '#D05416'
    },
    transient: {
      foreground: '#006AFF'
    }
  },
  AccordionHeader: {
    backgroundColor: '#FFF',
    backgroundColorHover: '#F6F6FA',
    borderRadius: 4,
    padding: 16,
    textDecorationHover: 'underline'
  },
  AccordionItem: {
    borderColor: '#D1D1D5',
    borderRadius: 4,
    borderWidth: 1,
    spacing: 8
  },
  AccordionPanel: {
    backgroundColor: '#FFF',
    borderColor: '#D1D1D5',
    borderRadius: 4,
    borderWidth: 1,
    padding: 16,
    margin: 0
  },
  Adornment: {
    borderRadius: 4,
    boxShadow: {
      focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
    },
    Left: {
      paddingLeft: 0,
      borderLeft: 0,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    Right: {
      paddingRight: 0,
      borderRight: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    ReadOnly: {
      backgroundColor: 'transparent',
      borderColor: 'transparent'
    }
  },
  Alert: {
    borderRadius: 4,
    Toast: {
      Body: {
        flex: '1 1 0'
      },
      Action: {
        flex: '1 1 100%',
        iconSize: 24,
        marginLeft: 'sm',
        marginTop: 8,
        order: 2
      }
    }
  },
  Anchor: {
    textDecoration: 'underline',
    defaultColor: '#0D4599',
    focusColor: '#0D4599',
    visitedColor: '#5B33AD',
    hoverColor: '#001751',
    activeColor: '#000',
    inverseColor: '#FFF',
    inverseHoverColor: '#F9F9FB',
    inverseActiveColor: '#F1F1F4',
    inverseVisitedColor: '#CE8DFF'
  },
  Avatar: {
    sizes: {
      xs: 24,
      sm: 32,
      md: 48,
      lg: 64,
      xl: 96,
      xxl: 160
    },
    fontTypes: {
      xs: 'bodySmallHeading',
      sm: 'h6',
      md: 'h5',
      lg: 'h4',
      xl: 'h3',
      xxl: 'h1'
    },
    iconColorOnLight: '#A7A6AB',
    iconColorOnDark: '#FFF',
    defaultBackgroundColor: '#F1F1F4',
    colorOnLight: '#2A2A33',
    colorOnDark: '#FFF',
    borderRadius: '50%'
  },
  AvatarBadge: {
    badgeSizes: {
      xxl: 48,
      xl: 36,
      lg: 28
    },
    iconSizes: {
      xxl: 32,
      xl: 24,
      lg: 16
    },
    foregroundColor: '#FFF',
    backgroundColor: '#006AFF',
    borderColor: '#FFF',
    borderRadius: '50%',
    borderWidth: 2
  },
  Banner: {
    borderRadius: 0,
    boxShadow: 'none',
    withCloseButton: {
      actionBodyMarginRight: 16,
      actionBodyMarginLeft: 0
    }
  },
  Button: {
    fontType: 'bodyHeading',
    fontTypeSmall: 'bodySmallHeading',
    borderRadius: 4,
    borderWidth: 1,
    horizontalPadding: 16,
    targetSize: 44,
    margin: 0,
    transitionDuration: 0.2,
    transitionProperty: 'background-color, border-color, color',
    transitionTimingFunction: 'ease',
    pressed: {
      borderWidth: 2,
      horizontalPadding: 15
    },
    primary: {
      fontColor: '#FFF',
      fontColorHover: '#FFF',
      fontColorActive: '#FFF',
      fontColorPressed: '#0D4599',
      fontColorPressedHover: '#001751',
      fontColorPressedActive: '#001751',
      borderColor: '#006AFF',
      borderColorHover: '#0D4599',
      borderColorActive: '#001751',
      borderColorPressed: '#0D4599',
      borderColorPressedHover: '#0D4599',
      borderColorPressedActive: '#001751',
      backgroundColor: '#006AFF',
      backgroundColorHover: '#0D4599',
      backgroundColorActive: '#001751',
      backgroundColorPressed: '#F2FAFF',
      backgroundColorPressedHover: '#E0F2FF',
      backgroundColorPressedActive: '#E0F2FF'
    },
    secondary: {
      fontColor: '#006AFF',
      fontColorHover: '#0D4599',
      fontColorActive: '#001751',
      fontColorPressed: '#FFF',
      fontColorPressedActive: '#0D4599',
      borderColor: '#006AFF',
      borderColorHover: '#0D4599',
      borderColorActive: '#001751',
      borderColorPressed: '#0D4599',
      borderColorPressedHover: '#001751',
      borderColorPressedActive: '#0D4599',
      backgroundColor: '#FFF',
      backgroundColorHover: '#F2FAFF',
      backgroundColorActive: '#E0F2FF',
      backgroundColorPressed: '#0D4599',
      backgroundColorPressedHover: '#001751',
      backgroundColorPressedActive: '#F2FAFF'
    },
    tertiary: {
      fontColor: '#2A2A33',
      fontColorHover: '#2A2A33',
      fontColorActive: '#2A2A33',
      fontColorPressed: '#2A2A33',
      borderColor: '#A7A6AB',
      borderColorHover: '#A7A6AB',
      borderColorActive: '#54545A',
      borderColorPressed: '#006AFF',
      backgroundColor: '#FFF',
      backgroundColorHover: '#F1F1F4',
      backgroundColorActive: '#D1D1D5',
      backgroundColorPressed: '#F2FAFF',
      backgroundColorPressedHover: '#E0F2FF',
      backgroundColorPressedActive: '#D1D1D5'
    },
    caution: {
      fontColor: '#FFF',
      fontColorHover: '#FFF',
      fontColorActive: '#A3000B',
      fontColorPressed: '#A3000B',
      fontColorPressedActive: '#FFF',
      borderColor: '#A3000B',
      borderColorHover: '#7C0012',
      borderColorActive: '#A3000B',
      borderColorPressed: '#A3000B',
      backgroundColor: '#A3000B',
      backgroundColorHover: '#7C0012',
      backgroundColorActive: '#FFF',
      backgroundColorPressed: '#FFF',
      backgroundColorPressedHover: '#FFE3E2',
      backgroundColorPressedActive: '#A3000B'
    },
    primaryInverse: {
      fontColor: '#006AFF',
      fontColorHover: '#0D4599',
      fontColorActive: '#001751',
      borderColor: '#FFF',
      borderColorHover: '#FFF',
      borderColorActive: '#FFF',
      backgroundColor: '#FFF',
      backgroundColorHover: '#F2FAFF',
      backgroundColorActive: '#E0F2FF'
    },
    secondaryInverse: {
      fontColor: '#FFF',
      fontColorHover: '#2A2A33',
      fontColorActive: '#2A2A33',
      borderColor: '#FFF',
      borderColorHover: '#FFF',
      borderColorActive: '#FFF',
      backgroundColor: 'transparent',
      backgroundColorHover: '#F1F1F4',
      backgroundColorActive: '#D1D1D5'
    },
    icon: {
      marginX: 8
    }
  },
  Card: {
    backgroundColor: '#FFF',
    borderWidth: 1,
    borderColor: '#D1D1D5',
    borderColorPrimary: '#006AFF',
    borderRadius: 4,
    separatorColor: '#D1D1D5',
    padding: 'sm',
    borderWidthPrimary: 3,
    section: {
      paddingBottom: 24,
      marginBottom: 24,
      borderBottomWidth: 1
    },
    interactive: {
      backgroundColor: {
        hover: '#F2FAFF',
        pressed: '#E0F2FF'
      },
      transitionProperty: 'background-color, box-shadow, border-color',
      transitionDuration: 0.2,
      transitionTimingFunction: 'ease',
      borderColor: {
        active: '#006AFF',
        hover: '#0D4599',
        pressed: '#001751'
      },
      borderWidth: {
        pressed: 2
      }
    }
  },
  CardButton: {
    fontType: 'h6',
    fontColor: '#006AFF',
    padding: 0,
    borderWidthTop: 1,
    paddingTop: 16,
    marginTop: 24,
    textAlign: 'center',
    width: '100%',
    textDecoration: {
      hover: 'underline'
    }
  },
  CardHeader: {
    fontType: 'h5',
    marginTop: 0,
    marginBottom: 24,
    borderBottomWidth: 1,
    paddingBottom: 16
  },
  CarouselHeader: {
    gridGap: 32,
    paddingBottom: 8
  },
  CarouselScrollContainer: {
    margin: 0,
    scrollOffset: {
      paddingTop: 8,
      paddingBottom: 18,
      scrollPaddingY: 0
    }
  },
  CarouselSkipLink: {
    height: 44,
    background: '#FFF',
    margin: 0,
    width: '100%'
  },
  CarouselNavControls: {
    gridColumnGap: 16
  },
  Checkbox: {
    backgroundColor: '#FFF',
    borderColor: '#A7A6AB',
    borderColorHover: '#006AFF',
    borderColorPressed: '#001751',
    borderColorDisabled: '#D1D1D5',
    borderColorActive: '#006AFF',
    borderColorActiveHover: '#0D4599',
    borderColorActivePressed: '#001751',
    backgroundColorActive: '#006AFF',
    backgroundColorActiveHover: '#0D4599',
    backgroundColorActivePressed: '#001751',
    borderWidth: 2,
    borderWidthChecked: 5,
    size: 20
  },
  Chip: {
    avatarSize: 24,
    borderRadius: '999px',
    borderWidth: 1,
    boxShadow: {
      default: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
      focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
    },
    chevronPadding: 32,
    chevronPosX: 9,
    fontColor: '#2A2A33',
    fontType: 'bodySmallHeading',
    height: 28,
    horizontalSpacing: 8,
    iconPosX: 10,
    opacity: {
      disabled: 0.4
    },
    spinnerSize: 16,
    targetSize: 36,
    closeButton: {
      opacityActive: 0.6,
      colorActive: '#A7A6AB'
    },
    pressed: {
      backgroundColorHover: '#E0F2FF',
      borderWidth: 2,
      chevronPadding: 31,
      chevronPosX: 10,
      horizontalSpacing: 7,
      iconPosX: 9
    }
  },
  CloseButton: {
    buttonSize: 24,
    iconColor: '#0A0A14',
    border: 0,
    backgroundColor: '#F1F1F4',
    backgroundColorInverse: 'rgba(255, 255, 255, 0.3)',
    padding: 8,
    margin: -8,
    boxShadowFocus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF',
    borderRadius: '50%'
  },
  ComboboxInput: {
    tagMargin: 4,
    minInputWidth: '25%',
    boxShadow: {
      focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
    },
    TagCloseButton: {
      opacity: {
        disabled: 1
      },
      cursor: {
        disabled: 'default'
      }
    },
    select: {
      basePaddingSize: 'xs'
    },
    Listbox: {
      border: 0
    },
    Input: {
      border: 0,
      padding: 0,
      boxShadow: 'none'
    }
  },
  ComboboxLoadingState: {
    verticalSpacing: 12
  },
  Combobox: {
    Dropdown: {
      width: '100%'
    },
    Listbox: {
      border: 0
    }
  },
  ComboboxOption: {
    Highlight: {
      fontWeight: 700,
      backgroundColor: 'transparent'
    }
  },
  Datepicker: {
    backgroundColor: '#FFF',
    Week: {
      paddingTop: 8
    },
    DayHeader: {
      height: 'xs',
      lineHeight: 36,
      borderBottomWidth: 1,
      borderColor: '#D1D1D5',
      paddingTop: 0,
      textAlign: 'center'
    },
    Date: {
      height: 40,
      padding: 4
    }
  },
  DatePickerButton: {
    borderRadius: '50%',
    size: 36,
    padding: 0,
    Icon: {
      margin: 0
    }
  },
  DatePickerSelect: {
    caretSize: 28,
    paddingLeft: 4,
    boxShadow: {
      focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
    },
    Select: {
      fontType: 'bodyHeading',
      padding: 0,
      paddingRight: 32,
      backgroundColor: {
        hover: '#F1F1F4'
      }
    },
    Button: {
      top: 0,
      right: 0,
      icon: {
        size: 10,
        rotate: '90deg'
      }
    }
  },
  DetailedIcon: {
    noFill: 'none',
    white: '#FFF',
    defaultSize: 44,
    info: {
      foregroundColor: '#0D4599',
      secondaryColor: '#A6E5FF',
      accentColor: '#F2A619'
    },
    success: {
      foregroundColor: '#055E16',
      secondaryColor: '#63E37D',
      accentColor: '#F2A619'
    }
  },
  Dialog: {
    minWidth: 200,
    maxWidth: 360,
    headingFontType: 'h5',
    borderRadius: 8,
    backgroundColor: '#FFF',
    boxShadow: '0 8px 12px 0 rgba(0, 0, 0, 0.3)'
  },
  Divider: {
    lengths: {
      auto: 'auto',
      fixed: 144,
      fluid: '100%'
    },
    regular: {
      backgroundColor: '#D1D1D5',
      thickness: 1
    },
    emphasized: {
      backgroundColor: '#FFD237',
      thickness: 2
    }
  },
  Dropdown: {
    borderRadius: 4,
    horizontalSpacing: 16,
    verticalSpacing: 12,
    zIndex: 100011,
    Footer: {
      margin: 0
    }
  },
  DropdownHeading: {
    fontType: 'bodySmallHeading',
    fontColor: '#596B82',
    iconSize: 'sm',
    backgroundColor: '#F6F6FA',
    horizontalSpacing: 16,
    verticalSpacing: 12,
    Icon: {
      marginRight: 8
    }
  },
  DropdownIcon: {
    iconColor: '#006AFF',
    size: 'md'
  },
  Form: {
    FormField: {
      marginBottom: 16
    },
    FormActions: {
      marginTop: 32
    }
  },
  FormField: {
    Label: {
      paddingBottom: 4
    },
    Help: {
      marginTop: 4
    },
    LabeledControl: {
      marginLeft: 8
    },
    ButtonGroup: {
      marginTop: 8
    }
  },
  FormHelp: {
    fontType: 'finePrint',
    fontColor: '#596B82',
    error: {
      fontColor: '#A3000B'
    }
  },
  Gleam: {
    height: 20,
    padding: 6,
    fontType: 'bodySmallHeading',
    borderRadius: '999px',
    default: {
      fontColor: '#FFF',
      backgroundColor: '#DB3A00',
      inverse: {
        fontColor: '#FFF',
        backgroundColor: '#DB3A00'
      }
    },
    info: {
      fontColor: '#FFF',
      backgroundColor: '#0D4599',
      inverse: {
        fontColor: '#001751',
        backgroundColor: '#E0F2FF'
      }
    },
    new: {
      fontColor: '#FFF',
      backgroundColor: '#128A29',
      inverse: {
        fontColor: '#055E16',
        backgroundColor: '#D8F4DE'
      }
    }
  },
  GleamWrapper: {
    position: {
      top: 8,
      right: 8
    }
  },
  GridContent: {
    backgroundColor: '#FFF',
    borderRadius: 4
  },
  Heading: {
    defaultFontFamily: {
      h0: 'sansSerif',
      h1: 'sansSerif',
      h2: 'sansSerif',
      h3: 'sansSerif',
      h4: 'sansSerif',
      h5: 'sansSerif',
      h6: 'sansSerif'
    }
  },
  IconButton: {
    size: {
      xs: 28,
      sm: 36,
      md: 44,
      lg: 56
    },
    circle: {
      borderRadius: '50%'
    }
  },
  InlineFeedback: {
    fontType: 'body',
    iconSize: 24,
    paddingLeft: 'sm'
  },
  Input: {
    fontType: 'body',
    borderWidth: 1,
    horizontalSpacing: 16,
    fontColor: '#2A2A33',
    fontColorPlaceholder: '#596B82',
    backgroundColor: '#F6F6FA',
    backgroundColorAutofill: '#E0F2FF',
    backgroundColorInteractive: '#FFF',
    borderRadius: 4,
    borderColor: '#D1D1D5',
    borderColorError: '#A3000B',
    borderColorInteractive: '#006AFF',
    borderColorHover: '#0D4599',
    adornmentColor: '#54545A',
    focus: {
      boxShadow: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
    },
    readonly: {
      paddingLeft: 0,
      paddingRight: 0,
      backgroundColor: 'transparent'
    }
  },
  Label: {
    fontTypes: {
      md: 'bodySmallHeading',
      lg: 'bodyHeading'
    },
    asteriskColor: '#A3000B',
    optionalColor: '#596B82'
  },
  LabeledControl: {
    fontType: 'body',
    desiredHeight: 44,
    Label: {
      paddingLeft: 8,
      paddingRight: 8
    }
  },
  LabeledInput: {
    fontTypeInput: 'body',
    fontTypeLabel: 'finePrintHeading',
    scale: 0.75,
    transition: '0.15s all',
    verticalSpacing: 8,
    horizontalSpacing: 16,
    paddingBase: 15
  },
  LabeledRatingStars: {
    marginRight: 8,
    buttonType: 'secondary',
    fontType: 'bodySmall'
  },
  List: {
    fontType: 'body',
    borderColor: '#D1D1D5',
    borderWidth: 1,
    paddingLeft: 32,
    Item: {
      paddingTop: 'xs',
      paddingBottom: 0,
      horizontalTable: {
        paddingLeft: 16,
        paddingRight: 16
      }
    }
  },
  Listbox: {
    borderRadius: 4,
    sizes: {
      md: 220
    }
  },
  ListboxGroupLabel: {
    fontType: 'bodySmallHeading',
    fontColor: '#596B82',
    backgroundColor: '#F6F6FA',
    textTransform: 'uppercase'
  },
  ListboxOption: {
    backgroundColor: '#FFF',
    backgroundColorHover: '#F2FAFF',
    backgroundColorActive: '#F2FAFF',
    backgroundColorPressed: '#E0F2FF',
    fontType: 'body',
    iconSize: 'sm',
    iconColor: '#596B82',
    mediaSize: 24,
    metaColor: '#596B82',
    horizontalSpacing: 16,
    verticalSpacing: 12,
    Label: {
      fontWeight: 700
    }
  },
  LoadingMask: {
    opacity: 0.2
  },
  Mask: {
    backgroundColor: '#000'
  },
  MenuContent: {
    fontType: 'finePrint',
    horizontalSpacing: 16,
    verticalSpacing: 12,
    margin: 0
  },
  MenuItem: {
    backgroundColor: '#FFF',
    backgroundColorHover: '#F2FAFF',
    backgroundColorActive: '#E0F2FF',
    border: 0,
    fontColor: '#2A2A33',
    fontType: 'body',
    horizontalSpacing: 16,
    verticalSpacing: 12,
    textAlign: 'left',
    textDecoration: {
      hover: 'none'
    },
    anchor: {
      textDecoration: {
        hover: 'underline'
      },
      color: {
        hover: '#001751'
      }
    },
    Icon: {
      size: 'sm',
      color: '#2A2A33',
      marginRight: 8
    }
  },
  Modal: {
    viewportPaddingVertical: 48,
    viewportPaddingHorizontal: 16,
    zIndex: 100002,
    boxShadow: '0 15px 30px 0 rgba(0, 0, 0, 0.3)'
  },
  ModalDialog: {
    padding: 16,
    separatorColor: '#D1D1D5',
    separatorWidth: 1,
    borderRadius: 8,
    sizes: {
      xs: 360,
      sm: 540,
      md: 720,
      lg: 900,
      xl: 1080,
      fullScreen: 100
    },
    fullscreen: {
      borderRadius: 0,
      padding: 0
    }
  },
  NumberRating: {
    iconFontSize: 14,
    color: '#006AFF',
    Text: {
      marginRight: 4
    }
  },
  Page: {
    backgroundColor: '#F6F6FA',
    maxWidth: 1232,
    horizontalPadding: 24,
    horizontalPaddingMobile: 16,
    verticalMargin: 32
  },
  PaginationButton: {
    radius: '50%',
    size: 44,
    padding: 0
  },
  PaginationItem: {
    marginY: 0,
    marginX: 2,
    textAlign: 'center'
  },
  PaginationJumpItem: {
    marginY: 0,
    marginX: 8
  },
  PaginationList: {
    margin: 0,
    padding: 0,
    alignItems: 'center'
  },
  PhotoCarousel: {
    focusBoxShadow: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF',
    animations: {
      defaultDuration: 0.2,
      defaultTimingFunction: 'cubic-bezier(.58, .92, .57, .92)'
    },
    controlIcon: {
      color: '#FFF',
      transition: {
        easing: 'ease',
        duration: 0.2,
        property: 'opacity'
      },
      opacity: {
        active: 1,
        inactive: 0
      },
      zIndex: {
        active: 1,
        inactive: -1
      },
      previous: {
        filter: 'drop-shadow(2px 0 2px rgba(0, 0, 0, 0.3))'
      },
      next: {
        filter: 'drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.3))'
      }
    },
    keyboardInstructions: {
      bottom: 30,
      transition: {
        duration: 0.4,
        property: 'all'
      }
    },
    dots: {
      backgroundColor: 'rgba(42,42,51,0.6)',
      borderRadius: '999px',
      paddingX: 4,
      paddingY: 2
    },
    dot: {
      backgroundColor: '#FFF',
      borderRadius: '50%',
      opacity: 0.6,
      boxShadow: 'none',
      marginY: 0,
      marginX: 4,
      position: {
        bottom: 6
      },
      size: {
        sm: 4,
        md: 6,
        lg: 8
      },
      active: {
        opacity: 1
      },
      transition: {
        easing: 'linear',
        duration: 0.15,
        property: 'all',
        delay: 0
      }
    },
    slide: {
      horizontalTranslations: {
        left: -100,
        center: 0,
        right: 100
      },
      zIndices: {
        left: 1,
        center: 2,
        right: 1
      }
    }
  },
  Popover: {
    maxHeight: 320,
    headingFontType: 'h6',
    padding: 16,
    arrowOuterSize: 40,
    arrowInnerSize: 17,
    arrowAlignStart: -9,
    arrowAlignCenter: 12,
    arrowAlignEnd: 31,
    arrowZIndex: 100011,
    separatorColor: '#D1D1D5',
    separatorWidth: 1,
    icon: {
      size: 24
    },
    Dialog: {
      zIndex: 100011,
      borderRadius: 4,
      gradientDirection: '180deg',
      startingColor: 'rgba(255, 255, 255, 0)',
      startingColorPosition: '0%',
      endingColorPosition: '100%'
    }
  },
  ProgressMeter: {
    sizes: {
      sm: 8,
      md: 16
    },
    backgroundColor: '#A6B3C4',
    borderRadius: 4,
    indicatorColorInProgress: '#0D4599',
    indicatorColorCompleted: '#3DCA5A',
    transition: '0.2s ease-in-out'
  },
  ProgressStepper: {
    currentStepSize: 36,
    nonInteractiveStepSize: 4,
    interactiveStepSize: 20,
    nonInteractiveLabelColor: '#596B82',
    interactiveLabelColor: '#0D4599',
    stepBorderWidth: 6,
    stepPaddingX: 2,
    tagMarginTop: 4,
    labelFontType: 'bodySmall',
    labelOffset: 12,
    labelLineHeight: 24,
    backgroundColor: '#A6B3C4',
    indicatorColor: '#0D4599',
    stepBackgroundColor: '#FFF',
    activeStepBackgroundColor: '#006AFF',
    activeStepBorderColor: '#FFF',
    activeStepLabelColor: '#2A2A33',
    activeStepBoxShadow: 'inset 0 0 0 2px #006AFF',
    boxShadowRing: '0 0 0 8px rgba(13,69,153,0.2)',
    ringColor: 'rgba(13,69,153,0.2)',
    ringSize: 16,
    status: {
      complete: {
        foreground: '#0D4599',
        boxShadow: 'inset 0 0 0 2px #0D4599'
      },
      incomplete: {
        foreground: '#0D4599',
        boxShadow: 'inset 0 0 0 2px #0D4599'
      },
      warning: {
        foreground: '#E96E2F',
        boxShadow: 'inset 0 0 0 2px #0D4599',
        iconSize: 24,
        filler: {
          width: 4,
          height: 12
        }
      },
      error: {
        foreground: '#E82B27',
        boxShadow: 'inset 0 0 0 2px #E82B27'
      },
      none: {
        foreground: 'inherit',
        boxShadow: ''
      }
    },
    label: {
      lineHeight: 24,
      marginTop: {
        current: 0
      },
      fontWeight: {
        current: 700,
        interactive: 700
      }
    },
    dot: {
      borderRadius: '50%',
      transition: {
        property: {
          interactive: 'transform'
        },
        duration: {
          interactive: 0.2
        },
        easing: {
          interactive: 'ease'
        }
      }
    }
  },
  PropertyCard: {
    action: {
      columnGap: 16,
      icon: {
        size: 24
      }
    },
    badge: {
      backgroundColor: {
        default: 'black',
        notification: 'orangeRed400',
        zillow: 'blue400'
      },
      borderRadius: '999px',
      fontColor: {
        default: '#FFF',
        notification: '#FFF',
        zillow: '#FFF'
      },
      fontType: 'finePrintHeading',
      horizontalPadding: 8,
      opacity: {
        default: 0.6,
        notification: 1,
        zillow: 1
      },
      verticalPadding: 2
    },
    cardBody: {
      borderRadius: 4,
      boxShadow: {
        flag: '0 4px 8px 0 rgba(0, 0, 0, 0.3)',
        hover: {
          flag: '0 8px 12px 0 rgba(0, 0, 0, 0.3)'
        },
        focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
      },
      gridTemplate: {
        large: '177px 1fr auto',
        small: '123px minmax(112px, 1fr)',
        horizontal: '116px 1fr',
        flag: '120px 1fr'
      },
      padding: 0,
      color: {
        hover: '#FFF'
      }
    },
    data: {
      gap: 8,
      pipeColor: '#A7A6AB',
      lineHeight: 1,
      marginBottom: 8,
      marginTop: 8,
      childrenWidth: {
        one: '6em',
        two: '95%',
        three: '85%'
      },
      title: {
        fontColor: '#2A2A33',
        fontType: {
          large: 'h5',
          small: 'h6',
          horizontal: 'h5',
          flag: 'h6'
        },
        fontFamily: 'sansSerif'
      },
      body1: {
        fontColor: '#2A2A33',
        fontType: 'bodySmall',
        fontFamily: 'sansSerif'
      },
      body2: {
        fontColor: '#2A2A33',
        fontType: 'bodySmall',
        fontFamily: 'sansSerif'
      },
      body3: {
        fontColor: '#2A2A33',
        fontType: 'bodySmall',
        fontFamily: 'sansSerif'
      },
      additionalInfo: {
        fontColor: '#596B82',
        fontType: 'legal',
        fontFamily: 'sansSerif'
      },
      wrapper: {
        padding: {
          flag: {
            Y: 4,
            X: 8
          },
          default: 8
        }
      }
    },
    fallbackImage: {
      fill: '#DEE3E6',
      size: {
        large: 70,
        small: 42,
        horizontal: 42,
        flag: 32
      }
    },
    flexArea: {
      padding: 8
    },
    gridTemplateAreas: {
      large: '"photo" "data" "flex"',
      small: '"photo" "data"',
      horizontal: '"photo data"',
      flag: '"photo data"'
    },
    loading: {
      backgroundColor: '#F1F1F4',
      backgroundImage: 'linear-gradient(to right, #F1F1F4, #F9F9FB, #F1F1F4)'
    },
    maxWidth: {
      large: 386,
      small: 244,
      horizontal: 393,
      flag: 332
    },
    minWidth: {
      large: 286,
      small: 144,
      horizontal: 293,
      flag: 232
    },
    mls: {
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.5) 100%)',
      fontColor: '#FFF',
      fontWeight: 700,
      fontType: {
        large: 'finePrintHeading',
        small: 'legal',
        horizontal: 'legal',
        flag: 'legal'
      },
      textShadow: '0 1px 1px rgba(0, 0, 0, 0.2)',
      logo: {
        maxHeight: 23,
        maxWidth: 100
      },
      text: {
        align: {
          large: 'right',
          default: 'left'
        }
      },
      footer: {
        gap: 8,
        templateColumns: '1fr min-content',
        text: {
          paddingBottom: 2,
          fontWeight: 700
        },
        padding: {
          top: 8,
          right: 4,
          bottom: 4,
          left: 8
        }
      }
    },
    photo: {
      backgroundBlur: 8,
      backgroundColor: '#F6F6FA',
      borderRadius: 4,
      gridRows: 'auto 1fr auto',
      animation: {
        duration: 1.5,
        iterations: 'infinite'
      },
      header: {
        gap: 16,
        marginTop: 8,
        padding: {
          X: 8,
          Y: 0
        }
      }
    },
    popperMenu: {
      iconSize: 24,
      default: {
        fill: 'transparent',
        backgroundColor: {
          hover: 'transparent'
        }
      },
      boxShadow: {
        focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
      }
    },
    saveArea: {
      gap: 16,
      marginTop: 8,
      marginRight: 8
    },
    saveButton: {
      padding: {
        top: 8,
        right: 8,
        bottom: 16,
        left: 16
      },
      border: 0,
      icon: {
        size: 32,
        shadow: '0 2px 4px rgba(0,0,0,0.3)',
        fill: {
          default: 'rgba(0, 0, 0, 0.5)',
          hover: 'rgba(0, 0, 0, 0.75)'
        }
      }
    },
    width: {
      flag: 282
    }
  },
  Range: {
    width: '100%',
    margin: {
      X: 0,
      Y: 11
    },
    boxShadow: {
      default: 'none',
      focus: 'none'
    },
    outline: {
      focus: 'none'
    },
    Thumb: {
      boxShadow: {
        focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
      }
    },
    Track: {
      width: '100%'
    },
    Tracks: {
      borderRadius: '50%'
    }
  },
  RatingStars: {
    fontSize: 16,
    valueColor: '#006AFF',
    noValueColor: '#D1D1D5',
    marginRight: 4
  },
  Radio: {
    backgroundColor: '#FFF',
    borderColor: '#A7A6AB',
    borderColorHover: '#006AFF',
    borderColorPressed: '#001751',
    borderColorDisabled: '#D1D1D5',
    borderColorActive: '#006AFF',
    borderColorActiveHover: '#0D4599',
    borderColorActivePressed: '#001751',
    borderWidth: 2,
    borderWidthChecked: 6,
    size: 20
  },
  SearchBox: {
    boxShadow: '0 0 18px rgba(0, 0, 0, 0.1)',
    fontType: 'h6',
    height: 60,
    heightLarge: 70,
    iconSize: 16,
    iconSizeLarge: 22,
    iconColor: '#54545A',
    large: {
      paddingLeft: 24
    }
  },
  Select: {
    chevronWidth: 40,
    chevronHeight: 28,
    chevronColor: '#54545A'
  },
  Slider: {
    thumbBackgroundColor: '#006AFF',
    thumbBackgroundColorInteractive: '#0D4599',
    thumbBorderColor: '#FFF',
    thumbBorderWidth: 4,
    thumbBoxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
    thumbFocusBoxShadow: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF',
    thumbBorderRadius: '50%',
    thumbLabelOffset: -60,
    thumbSize: 24,
    trackBackgroundColor: '#D1D1D5',
    trackBackgroundColorSelected: '#006AFF',
    trackBorderRadius: '999px',
    trackHeight: 2
  },
  SliderLabel: {
    caretSize: 8,
    caretMarginBottom: 8,
    fontType: 'body',
    fontColor: '#2A2A33',
    backgroundColor: '#FFF',
    borderRadius: 4,
    padding: {
      X: 12,
      Y: 8
    }
  },
  Spinner: {
    animation: {
      duration: 0.5,
      easing: 'linear',
      iterations: 'infinite'
    }
  },
  Switch: {
    transition: '0.4s all',
    iconColorOn: '#006AFF',
    iconColorOff: '#FFF',
    iconBackgroundColorOn: '#FFF',
    iconBackgroundColorOff: '#D1D1D5',
    borderColor: 'transparent',
    borderColorHover: '#D1D1D5',
    backgroundColor: '#F1F1F4',
    backgroundColorHover: '#F9F9FB',
    backgroundColorChecked: '#006AFF',
    backgroundColorCheckedHover: '#0D4599',
    focusBoxShadow: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF',
    borderRadius: '50%',
    sizes: {
      lg: {
        height: 30,
        width: 50,
        padding: 5
      },
      md: {
        height: 22,
        width: 38,
        padding: 4
      }
    }
  },
  SwitchGroup: {
    borderColor: '#D1D1D5',
    borderWidth: 1
  },
  Table: {
    borderColor: '#D1D1D5',
    borderWidth: 1,
    cellBackgroundColorLight: '#FFF',
    cellBackgroundColorDark: '#F9F9FB',
    focusBoxShadow: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF',
    fontType: {
      sm: 'bodySmall',
      md: 'bodySmall',
      lg: 'body'
    },
    headerBackgroundColorLight: '#FFF',
    headerBackgroundColorDark: '#F1F1F4',
    headerFontType: {
      sm: 'bodySmallHeading',
      md: 'bodySmallHeading',
      lg: 'bodyHeading'
    },
    headerSortIconColor: '#006AFF',
    horizontalPadding: {
      sm: 16,
      md: 16,
      lg: 16
    },
    rowBackgroundColorHover: '#F2FAFF',
    rowBackgroundColorSelected: '#E0F2FF',
    verticalPadding: {
      sm: 8,
      md: 12,
      lg: 16
    }
  },
  Tag: {
    borderRadius: 4,
    boxShadow: {
      focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
    },
    colors: {
      fontType: 'body',
      iconSize: 24,
      error: {
        background: '#FFE3E2',
        border: '#E82B27',
        foreground: '#E82B27',
        fontColor: '#A3000B',
        darkBackground: '#A3000B'
      },
      info: {
        fontColor: '#001751',
        background: '#E0F2FF'
      },
      success: {
        background: '#D8F4DE',
        border: '#128A29',
        foreground: '#128A29',
        fontColor: '#055E16',
        darkBackground: '#055E16'
      },
      warning: {
        background: '#FFF8E1',
        border: '#C88205',
        foreground: '#E96E2F',
        fontColor: '#8A5700',
        darkBackground: '#D05416'
      },
      transient: {
        foreground: '#006AFF'
      },
      gray: {
        fontColor: '#2A2A33',
        background: '#F1F1F4'
      },
      closeable: {
        fontColor: '#2A2A33',
        background: '#DEE3E6'
      },
      purple: {
        fontColor: '#5B33AD',
        background: '#F0E3FF'
      },
      aqua: {
        fontColor: '#03698C',
        background: '#D5F3F9'
      },
      orange: {
        fontColor: '#933100',
        background: '#F8CFBA'
      },
      transparent: {
        fontColor: '#FFF',
        background: 'rgba(0,0,0,0.6)'
      }
    },
    fontTypes: {
      sm: 'finePrintHeading',
      md: 'bodySmallHeading'
    },
    horizontalPadding: {
      sm: 4,
      md: 8
    },
    verticalPadding: 2,
    targetPadding: 8,
    closeButtonSize: 16,
    closeButton: {
      color: '#2A2A33',
      boxShadow: {
        focus: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF'
      },
      opacity: {
        hover: 0.6,
        active: 0.4
      },
      borderRadius: '50%'
    }
  },
  Tabs: {
    backgroundColor: '#FFF',
    fontColorHover: '#006AFF',
    selectedTabIndicatorColor: '#006AFF',
    selectedTabIndicatorHeight: 4,
    Panel: {
      padding: 16
    },
    Tab: {
      fontWeight: 400,
      default: {
        borderRadius: 0,
        borderColor: '#D1D1D5',
        padding: 16,
        transition: {
          duration: 0.2,
          easing: 'ease-out',
          property: 'flex-shrink'
        }
      },
      file: {
        padding: 16,
        transition: {
          duration: 0.2,
          easing: 'ease-out',
          property: 'flex-shrink'
        },
        gradientColor: {
          hover: '#F1F1F4',
          active: '#D1D1D5'
        }
      }
    }
  },
  TextButton: {
    fontColor: '#0D4599',
    fontColorInverse: '#FFF',
    fontColorInversePressed: '#F1F1F4',
    fontColorPrimary: '#0D4599',
    fontColorPrimaryHover: '#001751',
    fontColorPrimaryPressed: '#000',
    fontColorSecondary: '#2A2A33',
    fontColorTertiary: '#596B82'
  },
  Toast: {
    maxWidth: 500,
    borderRadius: 4,
    margin: 16,
    Provider: {
      zIndex: 200000
    },
    AnimatedList: {
      margin: 0,
      padding: 0
    }
  },
  ToolTip: {
    DialogBody: {
      paddingX: 16,
      paddingY: 8
    }
  },
  TriggerButton: {
    borderRadius: '50%',
    boxShadow: '0 0 2px 3px #A6E5FF,0 0 2px 4px #006AFF',
    size: 16,
    helpCircleFillColor: '#FFF',
    helpCircleFillColorActive: '#D1D1D5',
    helpCircleFillColorHover: '#F1F1F4',
    helpCircleStrokeColor: '#A7A6AB',
    helpCircleStrokeColorActive: '#54545A',
    helpCircleStrokeColorHover: '#A7A6AB',
    helpQuestionFillColor: '#2A2A33',
    helpQuestionFillColorActive: '#2A2A33'
  },
  TriggerText: {
    borderBottomColor: '#0D4599',
    borderBottomColorHover: '#001751',
    borderBottomWidth: 1,
    borderBottomStyle: 'dashed',
    padding: 0
  },
  Upsell: {
    headingFontType: 'h6',
    rowMediaSize: 48,
    columnMediaSize: 80,
    fontColorInverse: '#FFF',
    iconBackgroundColorInteractive: 'rgba(255, 255, 255, 0.3)'
  },
  UpsellBanner: {
    fontType: 'h6',
    mediaSize: 44,
    boxShadow: '0 1px 1px 0 rgb(79, 79, 79, 0.3)',
    padding: 16
  },
  VerticalNav: {
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.3)',
    backgroundColor: '#FFF',
    borderColor: '#D1D1D5',
    borderRadius: 4
  },
  VerticalNavItem: {
    backgroundColor: 'transparent',
    backgroundColorHover: '#F2FAFF',
    backgroundColorActive: '#E0F2FF',
    fontColor: '#2A2A33',
    fontType: 'body',
    fontWeightActive: 700,
    horizontalSpacing: 24,
    verticalSpacing: 12,
    borderColor: 'transparent',
    borderColorActive: '#006AFF',
    borderWidth: 4,
    borderRadius: 4
  }
};
export var ThemeConstellation = withNamespace({
  constellation: theme
}, 'constellation');